"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookClinicPage = void 0;
var react_1 = __importStar(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var react_router_dom_1 = require("react-router-dom");
var booking_reasons_1 = require("../../../../api/calls/clinic_booking/booking_reasons");
var react_redux_1 = require("react-redux");
var nearest_clinics_1 = require("../../../../api/calls/clinic_booking/nearest_clinics");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var clinic_availability_1 = require("../../../../api/calls/clinic_booking/clinic_availability");
var book_clinic_1 = require("../../../../api/calls/clinic_booking/book_clinic");
var control_colors_1 = require("../../../../constants/control_colors");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var main_1 = require("../../../../reducers/slices/main");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var BookClinicPage = function () {
    var _a;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _b = (0, react_1.useState)(0), currentStep = _b[0], setCurrentStep = _b[1];
    var _c = (0, react_1.useState)([]), bookingReasons = _c[0], setBookingReasons = _c[1];
    var _d = (0, react_1.useState)([]), bookingReasonsAll = _d[0], setBookingReasonsAll = _d[1];
    var _e = (0, react_1.useState)(null), selectedReason = _e[0], setSelectedReason = _e[1];
    var _f = (0, react_1.useState)(true), isLoadindData = _f[0], setIsLoadindData = _f[1];
    var _g = (0, react_1.useState)(false), isTimeSlotModalOpen = _g[0], setIsTimeSlotModalOpen = _g[1];
    var _h = (0, react_1.useState)([]), clinicList = _h[0], setClinicList = _h[1];
    var _j = (0, react_1.useState)(null), selectedClinic = _j[0], setSelectedClinic = _j[1];
    var _k = (0, react_1.useState)(null), selectedDay = _k[0], setSelectedDay = _k[1];
    var _l = (0, react_1.useState)([]), timeSlots = _l[0], seTimeSlots = _l[1];
    var _m = (0, react_1.useState)(null), selectedTimeSlot = _m[0], setSelectedTimeSlot = _m[1];
    var _o = (0, react_1.useState)(null), selectedPlaceDetails = _o[0], setSelectedPlaceDetails = _o[1];
    var _p = (0, react_1.useState)(null), selectedAddress = _p[0], setSelectedAddress = _p[1];
    var _q = (0, react_1.useState)("self"), bookingFor = _q[0], setBookingFor = _q[1];
    var _r = (0, react_1.useState)({
        from_date: doshx_controls_web_1.Utilities.formatDateTime(new Date(), "YYYY-MM-DD"),
        to_date: doshx_controls_web_1.Utilities.formatDateTime(new Date().setDate(new Date().getDate() + 1), "YYYY-MM-DD"),
    }), appointmentDate = _r[0], setAppointmentDate = _r[1];
    var _s = (0, react_1.useState)({
        name: "",
        surname: "",
        cell_number: "",
        email: "",
        gender: null,
        birthday: null,
    }), petient = _s[0], setPetient = _s[1];
    (0, react_1.useEffect)(function () {
        setIsLoadindData(true);
        (0, booking_reasons_1.booking_reasons)().then(function (response) {
            var _a, _b;
            if (response.success) {
                var data_1 = [];
                (_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.reasons.forEach(function (reason) {
                    data_1.push({
                        label: reason.name,
                        value: reason.speciality_fhir_id,
                    });
                });
                setBookingReasons(data_1);
                setBookingReasonsAll((_b = response === null || response === void 0 ? void 0 : response.content) === null || _b === void 0 ? void 0 : _b.reasons);
                setIsLoadindData(false);
            }
            else {
                setIsLoadindData(false);
            }
        });
    }, [user]);
    (0, react_1.useEffect)(function () {
        if (bookingFor == "self") {
            setPetient({
                name: user === null || user === void 0 ? void 0 : user.name,
                surname: user === null || user === void 0 ? void 0 : user.surname,
                cell_number: user === null || user === void 0 ? void 0 : user.cell_number,
                email: user === null || user === void 0 ? void 0 : user.email,
                gender: user === null || user === void 0 ? void 0 : user.gender,
                birthday: user === null || user === void 0 ? void 0 : user.birthday,
            });
        }
        else {
            setPetient({
                name: "",
                surname: "",
                cell_number: "",
                email: "",
                gender: null,
                birthday: null,
            });
        }
    }, [bookingFor, user]);
    (0, react_1.useEffect)(function () {
        if (user && selectedReason && selectedAddress) {
            setIsLoadindData(true);
            (0, nearest_clinics_1.nearest_clinics)({
                booking_reason: selectedReason.booking_reason,
                organization_fhir_id: selectedReason.organization_fhir_id,
                latitude: selectedAddress.latitude,
                longitude: selectedAddress.longitude,
                speciality_fhir_id: selectedReason.speciality_fhir_id,
            }).then(function (response) {
                if (response.success) {
                    setClinicList(response === null || response === void 0 ? void 0 : response.content);
                    setIsLoadindData(false);
                }
                else {
                    setIsLoadindData(false);
                }
            });
        }
    }, [selectedReason, selectedAddress]);
    (0, react_1.useEffect)(function () {
        if (selectedClinic) {
            setIsLoadindData(true);
            (0, clinic_availability_1.clinic_availability)({
                booking_reason: selectedReason.booking_reason,
                location_fhir_id: selectedClinic.location_fhir_id,
                from_date: appointmentDate.from_date,
                to_date: appointmentDate.to_date,
                speciality_fhir_id: selectedReason.speciality_fhir_id,
                health_care_service_fhir_id: selectedClinic.health_care_service_fhir_id,
                //TO DO
            }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (response.success) {
                        seTimeSlots(response === null || response === void 0 ? void 0 : response.content);
                        setIsLoadindData(false);
                    }
                    else {
                        setIsLoadindData(false);
                    }
                    return [2 /*return*/];
                });
            }); });
        }
        //TO DO
    }, [selectedClinic, appointmentDate]);
    var validateUser = function () {
        var count = 0;
        if (!petient.name) {
            count++;
        }
        if (!petient.surname) {
            count++;
        }
        if (!petient.birthday) {
            count++;
        }
        if (!petient.gender) {
            count++;
        }
        return count > 0 ? false : true;
    };
    var onNext = function () {
        var nextStep = currentStep + 1;
        if (nextStep < customSteps.length) {
            setCurrentStep(nextStep);
        }
    };
    var onPrevious = function () {
        var nextStep = currentStep - 1;
        if (currentStep > 0) {
            setCurrentStep(nextStep);
        }
    };
    var getUserLocation = function () {
        setIsLoadindData(true);
        navigator.geolocation.getCurrentPosition(function (position) {
            setSelectedAddress({
                full_address: "User Location",
                longitude: position.coords.longitude,
                latitude: position.coords.latitude,
            });
        }, function (error) {
            console.error(error);
        });
    };
    var confirmBooking = function () { return __awaiter(void 0, void 0, void 0, function () {
        var local_time_zone_id, _slot;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    local_time_zone_id = selectedTimeSlot.local_time_zone_id, _slot = __rest(selectedTimeSlot, ["local_time_zone_id"]);
                    setIsLoadindData(true);
                    return [4 /*yield*/, (0, book_clinic_1.book_clinic)({
                            patient: petient,
                            reason: selectedReason,
                            clinic: selectedClinic,
                            slot: _slot,
                        }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                if (response.success) {
                                    onNext();
                                    setIsLoadindData(false);
                                }
                                else {
                                    dispatch((0, main_1.setMessageModal)({ title: "Booking Failed!", messages: [response.message] }));
                                    setIsLoadindData(false);
                                }
                                return [2 /*return*/];
                            });
                        }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var customSteps = [
        {
            // hidden: true,
            label: "Patient",
            component: (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.RadioButtonsControl, { title: "Clinic Booking For:", colors: control_colors_1.radio_colors, selectedValue: bookingFor, options: [
                            { label: "".concat(user === null || user === void 0 ? void 0 : user.name, " ").concat(user === null || user === void 0 ? void 0 : user.surname), value: "self" },
                            { label: "Other", value: "other" },
                        ], onChange: function (value) {
                            setBookingFor(value);
                        } }),
                    react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { size: "small", label: "Name *", borderColor: "border-borders", value: petient.name, errorText: "", onChange: function (v) {
                                setPetient(__assign(__assign({}, petient), { name: v }));
                            } }),
                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { size: "small", label: "Surname *", borderColor: "border-borders", value: petient.surname, errorText: "", onChange: function (v) {
                                setPetient(__assign(__assign({}, petient), { surname: v }));
                            } }),
                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { size: "small", label: "Phone", borderColor: "border-borders", value: petient.cell_number, errorText: "", onChange: function (v) {
                                setPetient(__assign(__assign({}, petient), { cell_number: v }));
                            } }),
                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { size: "small", label: "Email", borderColor: "border-borders", value: petient.email, errorText: "", onChange: function (v) {
                                setPetient(__assign(__assign({}, petient), { email: v }));
                            } }),
                        react_1.default.createElement(doshx_controls_web_1.DropdownControl, { options: [
                                { label: "Male", value: "Male" },
                                { label: "Female", value: "Female" },
                            ], borderColor: "border-borders", errorTextColor: "text-red-500", label: "Gender *", size: "small", value: petient.gender, onChange: function (v) {
                                setPetient(__assign(__assign({}, petient), { gender: v }));
                            } }),
                        react_1.default.createElement(doshx_controls_web_1.DatePickerControl, { label: "Date Of Birth *", size: "small", borderColor: "border-borders", inputFormat: "YYYY-MM-DD", errorText: "", value: petient.birthday, onChange: function (v) {
                                setPetient(__assign(__assign({}, petient), { birthday: doshx_controls_web_1.Utilities.formatDateTime(v, "YYYY-MM-DD") }));
                            } }))),
                react_1.default.createElement("div", { className: "flex flex-row" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Next", backgroundColor: "bg-primary", enabled: validateUser(), size: "small", onClick: function () {
                            onNext();
                        } })))),
        },
        {
            label: "Service",
            component: isLoadindData ? (react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "small", progressColor: "text-primary" })) : (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement(doshx_controls_web_1.DropdownControl, { options: bookingReasons, borderColor: "border-[#EEEEEE]", errorTextColor: "text-red-500", label: "Reason for visit", value: selectedReason === null || selectedReason === void 0 ? void 0 : selectedReason.speciality_fhir_id, onChange: function (v) {
                        var _a, _b;
                        //   console.log(v);
                        setSelectedReason({
                            speciality_fhir_id: v,
                            booking_reason: (_a = bookingReasonsAll.find(function (item) { return item.speciality_fhir_id == v; })) === null || _a === void 0 ? void 0 : _a.name,
                            organization_fhir_id: (_b = bookingReasonsAll.find(function (item) { return item.speciality_fhir_id == v; })) === null || _b === void 0 ? void 0 : _b.organization_fhir_id,
                        });
                    } }),
                react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Next", backgroundColor: "bg-primary", enabled: selectedReason ? true : false, size: "small", onClick: function () {
                            onNext();
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Back", size: "small", onClick: function () {
                            onPrevious();
                        } })))),
        },
        {
            label: "Location",
            component: (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Please enter your address or use your current location", size: "small", textColor: "text-black" }),
                react_1.default.createElement("div", { className: "flex flex-row gap-4 w-full" },
                    react_1.default.createElement("div", { className: "flex flex-col w-4/6" },
                        react_1.default.createElement(doshx_controls_web_1.AddressSearchControl, { value: selectedPlaceDetails, required: true, label: "Search & select address...", size: "small", onSelectionChange: function (addressObject) {
                                var _a, _b, _c, _d, _e, _f, _g;
                                if (addressObject) {
                                    setSelectedAddress({
                                        full_address: addressObject.fullAddress,
                                        longitude: addressObject.coordinates.lng.toString(),
                                        latitude: addressObject.coordinates.lat.toString(),
                                        line_one: (_a = addressObject.street_number) !== null && _a !== void 0 ? _a : "",
                                        line_two: (_b = addressObject.street_name) !== null && _b !== void 0 ? _b : "",
                                        town: (_c = addressObject.suburb) !== null && _c !== void 0 ? _c : "",
                                        city: (_d = addressObject.city) !== null && _d !== void 0 ? _d : "",
                                        province: (_e = addressObject.province) !== null && _e !== void 0 ? _e : "",
                                        country: (_f = addressObject.country) !== null && _f !== void 0 ? _f : "",
                                        postal_code: (_g = addressObject.postal_code) !== null && _g !== void 0 ? _g : "",
                                    });
                                }
                            } })),
                    react_1.default.createElement("div", { className: "flex flex-row w-2/6" },
                        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { size: "small", startIcon: pro_solid_svg_icons_1.faLocation, label: "My Location  ", onClick: function () {
                                getUserLocation();
                            } }))),
                react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                    selectedAddress && (react_1.default.createElement("div", { className: "flex flex-col" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Clinics close to:", size: "small", textColor: "text-black" }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.full_address, size: "small", textColor: "text-black", bold: true }))),
                    isLoadindData ? (react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "small", progressColor: "text-primary" })) : (clinicList.map(function (clinic, index) {
                        var _a, _b, _c, _d, _e;
                        return (react_1.default.createElement("div", { key: index, onClick: function () {
                                setSelectedClinic(clinic);
                                onNext();
                            }, className: "p-4 border  rounded-md cursor-pointer flex flex-row items-center ".concat(clinic == selectedClinic ? "border-primary" : "border-borders", " ") },
                            react_1.default.createElement("div", { className: "flex-1" },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: (_a = clinic === null || clinic === void 0 ? void 0 : clinic.clinic_name) !== null && _a !== void 0 ? _a : "", textColor: "text-black", bold: true, size: "small" }),
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: (_c = (_b = clinic === null || clinic === void 0 ? void 0 : clinic.address) === null || _b === void 0 ? void 0 : _b.line_one) !== null && _c !== void 0 ? _c : "", textColor: "text-black", size: "xsmall" }),
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: (_e = (_d = clinic === null || clinic === void 0 ? void 0 : clinic.address) === null || _d === void 0 ? void 0 : _d.line_two) !== null && _e !== void 0 ? _e : "", textColor: "text-black", size: "xsmall" })),
                            clinic == selectedClinic && (react_1.default.createElement("div", { className: "rounded-lg bg-primary px-2 py-1 flex flex-row items-center" },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "SELECTED", className: "cursor-pointer" //
                                    , textColor: "text-white", size: "xsmall" })))));
                    }))),
                react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Next", backgroundColor: "bg-primary", enabled: selectedAddress ? true : false && selectedClinic ? true : false, size: "small", onClick: function () {
                            onNext();
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Back", size: "small", onClick: function () {
                            onPrevious();
                        } })))),
        },
        {
            // hidden: true,
            label: "Time Slot",
            component: (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "flex flex-row gap-4 " },
                    react_1.default.createElement(doshx_controls_web_1.DatePickerControl, { label: "Choose Date:", size: "small", borderColor: "border-borders", inputFormat: "YYYY-MM-DD", errorText: "", value: appointmentDate.from_date, onChange: function (v) {
                            var myDate = new Date(v);
                            setAppointmentDate({
                                from_date: doshx_controls_web_1.Utilities.formatDateTime(v, "YYYY-MM-DD"),
                                to_date: doshx_controls_web_1.Utilities.formatDateTime(myDate.setDate(myDate.getDate() + 1), "YYYY-MM-DD"),
                            });
                        } })),
                react_1.default.createElement("div", { className: "flex flex-col gap-4 py-4" },
                    selectedAddress && (react_1.default.createElement("div", { className: "flex flex-col" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Available time slots for:", size: "small", textColor: "text-black" }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: selectedClinic === null || selectedClinic === void 0 ? void 0 : selectedClinic.clinic_name, size: "small", textColor: "text-black", bold: true }))),
                    isLoadindData ? (react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "small", progressColor: "text-primary" })) : (react_1.default.createElement("div", { className: "grid gap-4 grid-cols-2 md:grid-cols-6" }, timeSlots.map(function (slot, index) {
                        return (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: slot.date, textColor: "text-white", backgroundColor: "".concat(slot == selectedDay ? "bg-primary" : "bg-[#0132A9]"), size: "xsmall", onClick: function () {
                                setSelectedDay(slot);
                                if (slot != selectedDay) {
                                    setSelectedTimeSlot(null);
                                }
                                setIsTimeSlotModalOpen(true);
                            } }));
                    })))),
                react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Next", enabled: selectedTimeSlot ? true : false, backgroundColor: "bg-primary", size: "small", onClick: function () {
                            onNext();
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Back", size: "small", onClick: function () {
                            onPrevious();
                        } })))),
        },
        {
            // hidden: true,
            label: "Appointment Details",
            component: (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Confirm Booking Details", size: "small", textColor: "text-black" }),
                react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                    react_1.default.createElement("div", { className: " flex flex-row gap-2" },
                        react_1.default.createElement("div", { className: "flex flex-row gap-2" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faUser, size: "1x" }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Petient:", textColor: "text-black", size: "small" })),
                        react_1.default.createElement("div", { className: "" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "".concat(petient === null || petient === void 0 ? void 0 : petient.name, " ").concat(petient === null || petient === void 0 ? void 0 : petient.surname), textColor: "text-gray", size: "small", bold: true }))),
                    react_1.default.createElement("div", { className: " flex flex-row gap-2" },
                        react_1.default.createElement("div", { className: "flex flex-row gap-2" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faHospital, size: "1x" }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Clinic:", textColor: "text-black", size: "small" })),
                        react_1.default.createElement("div", { className: "" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: selectedClinic === null || selectedClinic === void 0 ? void 0 : selectedClinic.clinic_name, textColor: "text-gray", size: "small", bold: true }))),
                    react_1.default.createElement("div", { className: " flex flex-row gap-2" },
                        react_1.default.createElement("div", { className: "flex flex-row gap-2" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faClock, size: "1x" }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Date & Time:", textColor: "text-black", size: "small" })),
                        react_1.default.createElement("div", { className: "" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: (0, moment_timezone_1.default)(selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.start_time).tz("Africa/Johannesburg").format("dddd, MMMM Do YYYY, h:mm A"), textColor: "text-gray", size: "small", bold: true }))),
                    react_1.default.createElement("div", { className: " flex flex-row gap-2" },
                        react_1.default.createElement("div", { className: "flex flex-row gap-2" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faNotesMedical, size: "1x" }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Apointment for:", textColor: "text-black", size: "small" })),
                        react_1.default.createElement("div", { className: "" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: selectedReason === null || selectedReason === void 0 ? void 0 : selectedReason.booking_reason, textColor: "text-gray", size: "small", bold: true })))),
                isLoadindData ? (react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "small", progressColor: "text-primary" })) : (react_1.default.createElement("div", { className: "flex flex-row gap-4 items-center" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Book Clinic", backgroundColor: "bg-primary", size: "small", onClick: function () {
                            confirmBooking();
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Back", size: "small", onClick: function () {
                            onPrevious();
                        } }))))),
        },
        {
            // hidden: true,
            label: "Done",
            component: (react_1.default.createElement("div", { className: "flex flex-col items-left" },
                react_1.default.createElement("div", { className: "flex flex-col items-center  gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Completed", textColor: "text-success", size: "3xlarge", center: true }),
                    react_1.default.createElement("div", { className: "flex flex-col" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Your Booking was succesful.", textColor: "text-success", size: "medium", center: true }))),
                react_1.default.createElement("div", { className: " flex justify-center" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCircleCheck, size: "5x" })),
                react_1.default.createElement("div", { className: "pt-8 flex flex-row justify-center" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Booking History", size: "small", backgroundColor: "bg-primary", onClick: function () {
                            navigate("/clinic/booking/history");
                        } })))),
        },
    ];
    return (react_1.default.createElement("div", { className: "flex flex-col gap-8" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col lg:flex-row lg:items-start gap-4" },
            react_1.default.createElement("div", { className: "flex-grow" },
                react_1.default.createElement(doshx_controls_web_1.StepperControl, { currentStep: currentStep, steps: customSteps, stepsPadding: true, stepsBackgroundColor: "bg-white", stepPillBackgroundColor: "bg-primary", stepPillCompletedBackgroundColor: "bg-success", lineColor: "border-primary" }))),
        react_1.default.createElement(doshx_controls_web_1.ModalControl, { title: "Please select available time slot", onClose: function () {
                setIsTimeSlotModalOpen(false);
            }, open: isTimeSlotModalOpen, children: react_1.default.createElement("div", { className: "grid gap-4 grid-cols-2 md:grid-cols-6  p-4" }, (_a = selectedDay === null || selectedDay === void 0 ? void 0 : selectedDay.slots) === null || _a === void 0 ? void 0 : _a.map(function (slot, index) {
                return (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "".concat((0, moment_timezone_1.default)(slot.start_time).tz("Africa/Johannesburg").format("h:mm A"), " - ").concat((0, moment_timezone_1.default)(slot.end_time)
                        .tz("Africa/Johannesburg")
                        .format("h:mm A")), textColor: "text-white", backgroundColor: "".concat(slot == selectedTimeSlot ? "bg-primary" : "bg-[#0132A9]"), size: "xsmall", onClick: function () {
                        setSelectedTimeSlot(slot);
                    } }));
            })) })));
};
exports.BookClinicPage = BookClinicPage;
